import React from 'react'
import "../../App.css";

const Footer = () => {
  return (
    <div className="strokeMe" style={{textAlign:'center', marginBottom: 10}}>
        Made by 
    <a href="https://woodsy-studio.com/"
       style={{ cursor: "pointer" }}
    > Jenny</a> ❤️ 2024 - 2025
    </div>
  )
}

export default Footer